const state = {
    menuTypes: {
        1: '栏目',
        2: '菜单',
        3: '按钮'
    }
};
export default {
    namespaced: true,
    state
};
